// 50种颜色集合
const COLOR_LIST = [
  '#FEA47F',
  '#25CCF7',
  '#EAB543',
  '#55E6C1',
  '#CAD3C8',
  '#F97F51',
  '#1B9CFC',
  '#F8EFBA',
  '#58B19F',
  '#2C3A47',
  '#B33771',
  '#3B3B98',
  '#FD7272',
  '#9AECDB',
  '#D6A2E8',
  '#6D214F',
  '#182C61',
  '#FC427B',
  '#BDC581',
  '#82589F',
  '#36cfc9',
  '#4096ff',
  '#73d13d',
  '#f759ab',
  '#fa541c',
  '#DDA0DD',
  '#f5222d',
  '#faad14',
  '#7FFFD4',
  '#708069',
  '#fadb14',
  '#FF7F50',
  '#a0d911',
  '#13c2c2',
  '#1677ff',
  '#52c41a',
  '#eb2f96',
  '#d3f261',
  '#5cdbd3',
  '#69b1ff',
  '#95de64',
  '#ff85c0',
  '#082E54',
  '#ff7a45',
  '#33A1C9',
  '#A020F0',
  '#ffc53d',
  '#ff4d4f',
  '#ffec3d',
  '#228B22',
]
export default {
  data() {
    return {
      COLOR_LIST
    }
  },
  created() {
  },
  methods: {
  }
}